import React from 'react';
import PropTypes from 'prop-types';
import { menuToggler } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';

import FilterBar from './FilterBar';
import { colors } from '../styles';
import icons from './IconsList';
import SortDropdown from './SortDropdown';

const styles = css`
  .Filter_wrapper {
    display: flex;
    height: auto;
    width: 100%;
    flex-wrap: wrap;
    position: relative;
    .FiltersList_wrapper {
      width: 70%;
      background-color: ${colors.color1};
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: all .3s ease-out;
      @media(min-width: 992px) {
        width: 480px;
      }
      &:focus {
        outline: none;
      }
      .FiltersList_btn {
        font-weight: 700;
        text-transform: uppercase;
        width: 100%;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        color: #FFFFFF;
        letter-spacing: 0.87px;
        position: relative;
        @media(min-width: 992px) {
          height: 85px;
          font-size: 18px;
          letter-spacing: 2.84px;
        }
        ::before {
          content: '';
          background-image: url(${get(icons, 'filters')});
          background-repeat: no-repeat;
          background-size: contain;
          width: 17px;
          height: 18px;
          margin: 0 7px 0 0;
          @media(min-width: 992px) {
            margin: 0 10px 0 0;
            width: 22px;
            height: 23px;
          }
        }
        &:focus {
          outline: none;
        }
      }
      &:hover {
        background-color: ${colors.color1Darkest};
      }
      .FiltersList {
        display: none;
        position: absolute;
        top: 50px;
        left: 0;
        width: 100vw;
        background-color: ${colors.color1};
        padding: 20px;
        z-index: 2;
        max-width: 676px;
        @media(min-width: 576px) {
          width: 100%;
        }
        @media(min-width: 768px) {
          padding: 50px;
        }
        @media(min-width: 992px) {
          top: 86px;
          width: 676px;
        }
      }
      .FiltersList_open {
        display: block;
      }
    }

    .Sort_button {
      width: 30%;
      background-color: #000000;
      cursor: pointer;
      font-weight: 700;
      font-size: 13px;
      color: #FFFFFF;
      letter-spacing: 0.87px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      max-width: 300px;
      @media(min-width: 576px) {
        position: relative;
      }
      &:focus {
        outline: none;
      }
    }
  }
  .Filter_toogleMap {
    width: 100%;
    height: 45px;
    background-color: #F4F4F4;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 13px;
    color: #000000;
    letter-spacing: 0.87px;
    text-align: center;
    text-transform: uppercase;
    position: relative;
    cursor: pointer;
    background-position: calc(50% + 75px) center;
    background-repeat: no-repeat;
    &:focus {
      outline: none;
    }
    @media(min-width: 992px) {
      display: none;
    }
  }
  .Filter_showing {
    font-weight: 300;
    font-size: 15px;
    color: #1F1F1F;
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    height: 55px;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #fff;
    justify-content: center;
    @media(min-width: 992px) {
      padding: 0 40px;
      width: auto;
      flex: 1;
      background-color: #F4F4F4;
      height: 85px;
      justify-content: flex-start;
    }
  }
  .Filter_typeWrapper {
    width: 100%;
    height: 55px;
    display: flex;
    border: 2px solid #FFFFFF;
    margin: 10px 0 15px;
    @media(min-width: 768px) {
      height: 77px;
    }
  }
  .Filter_typeWrapperBtn {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 13px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 18px;
    padding: 0 10px;
    @media(min-width: 768px) {
      line-height: 24px;
      font-size: 17px;

    }
  }
  .Filter_typeWrapperBtn-active {
    color: #000000;
    background-color: #FFFFFF;
  }
  .Filter_extraBorder {
    border-left: 2px solid #FFFFFF;
    border-right: 2px solid #FFFFFF;
  }
  .Filter_typeText {
    font-weight: 700;
    font-size: 17px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 24px;
  }
`;

class Filters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filtersOpen: false,
      desktopSort: false,
    };
  }

  openFilters = () => {
    this.setState({
      filtersOpen: true,
    });
  }

  closeFilters = () => {
    this.setState({
      filtersOpen: false,
    });
  }
  openDesktopSort = () => {
    this.setState({
      desktopSort: !this.state.desktopSort,
    });
  }

  render() {
    const {
      activateMenu, isActiveMenu, viewMap, homes, plans, type, communities,
      sortOptions, onSortSelect, scrollRef, toggleView, activeSort,
    } = this.props;

    return (
      <div className={styles}>
        <div className="Filter_wrapper">
          <div className="FiltersList_wrapper">
            <span role="button" tabIndex="0" onClick={activateMenu('filter')} className="FiltersList_btn">Filters</span>
            <div className={`FiltersList ${isActiveMenu('filter') && 'FiltersList_open'}`}>
              <FilterBar
                {...this.props}
              />
            </div>
          </div>
          <span className="Sort_button order-lg-1" role="button" tabIndex="0" onClick={activateMenu('sort')}>
            <span className="Sort_buttonLabel">Sort By: </span>
            <SortDropdown
              className={`Sort_dropdown ${isActiveMenu('sort') && 'Sort_dropdownOpen'}`}
              sortOptions={sortOptions}
              onSortSelect={onSortSelect}
              scrollRef={scrollRef}
              activeSort={activeSort}
            />
          </span>
          <span
            className={`Filter_toogleMap ${type === 'plans' ? 'd-none' : ''}`}
            role="button"
            tabIndex={0}
            onClick={toggleView}
            style={{ backgroundImage: `url(${viewMap ? get(icons, 'listView') : get(icons, 'mapPin')})` }}
          >
            {`View on ${viewMap ? 'List' : 'Map'}`}
          </span>
          {
            type === 'plans' &&
            <span className="Filter_showing">Showing {plans.length} {plans.length > 1 ? 'Plans' : 'Plan'}</span>
          }
          {
            type === 'homes' &&
            <span className="Filter_showing">Showing {homes.length} {homes.length > 1 ? 'Homes' : 'Home'}</span>
          }
          {
            type === 'communities' &&
            <span className="Filter_showing">Showing {communities.length} {communities.length > 1 ? 'Communities' : 'Community'}</span>
          }
        </div>
      </div>
    );
  }
}

Filters.propTypes = {
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  onSortSelect: PropTypes.func.isRequired,
  toggleView: PropTypes.func,
  sortOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.arrayOf(PropTypes.object),
  communities: PropTypes.arrayOf(PropTypes.object),
  scrollRef: PropTypes.object,
  viewMap: PropTypes.bool,
  activeSort: PropTypes.object,
  type: PropTypes.string.isRequired,
};

Filters.defaultProps = {
  scrollRef: document.getElementsByTagName('body')[0],
  toggleView: undefined,
  viewMap: false,
  activeSort: null,
  homes: undefined,
  plans: undefined,
  communities: undefined,
  tab: 'All',
  changeTabHandler: undefined,
};

export default withData(
  {
    homes: true,
    plans: true,
    communities: true,
  },
)(menuToggler(Filters));



// WEBPACK FOOTER //
// ./src/components/Filters.js